<template>
  <div id="main-base">
    <app-nav></app-nav>
    <router-view></router-view>
    <footer-view></footer-view>
  </div>
</template>

<script>
  import AppNav from './AppNav.vue'
  import FooterView from './FooterView.vue'
  export default {
    components: { AppNav, FooterView }
  }
</script>

<style>
  #main-base {
    padding-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// MainBase.vue?10960372